import { Box } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { fetchReleaseInfo } from "apiClients/release.api";
import CustomModal from "components/common/Modal/CustomModal";
import Text from "components/common/Typography/Text";

interface ReleaseInfoModalProps {
  isOpen: boolean;
  onClose: (value: boolean) => void;
  title?: string;
}

const ReleaseInfoModal = ({ isOpen, onClose, title = "Release Information" }: ReleaseInfoModalProps) => {
  const { data } = useQuery({
    enabled: isOpen,
    queryKey: ["release-api"],
    queryFn: fetchReleaseInfo,
  });

  return (
    <CustomModal setOpen={onClose} open={isOpen} title={title} maxWidth="sm">
      <Box
        sx={{
          padding: 2,
        }}>
        <Box
          sx={{
            mb: 1,
          }}>
          <Text variant="h3">Neph-ui : {data?.ui?.version ? data?.ui?.version : "---"}</Text>
        </Box>
        <Box
          sx={{
            mb: 1,
          }}>
          <Text variant="h3">Neph-api : {data?.api?.version ? data?.api?.version : "---"}</Text>
        </Box>
        <Box
          sx={{
            mb: 1,
          }}>
          <Text variant="h3">Saya : {data?.saya?.version ? data?.saya?.version : "---"}</Text>
        </Box>
      </Box>
    </CustomModal>
  );
};

export default ReleaseInfoModal;
